module.exports = __webpack_public_path__ + "static/kuchnia-photo02-535c5a0ea97423b8c289436c7c8060a8.jpg";